var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"divider",class:[{ _horizontal: _vm.horizontal }],style:([{backgroundColor: _vm.color}, _vm.getOffset])})
}
var staticRenderFns = []

export { render, staticRenderFns }